import React, { FC } from 'react';

type Props = {
  classCss: string;
  props?: React.SVGProps<SVGSVGElement>;
};
const IconCheckWhite: FC<Props> = ({ classCss, props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 19"
      className={classCss}
      {...props}
    >
      <polygon
        fillRule="evenodd"
        points="7.607 17.492 22.066 3 24 4.934 7.607 21.328 0 13.721 1.902 11.787"
        transform="translate(0 -3)"
      />
    </svg>
  );
};

export default IconCheckWhite;
